import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2;
import { keyframes, styled } from 'styled-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var rotate = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var SVG = styled.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  color: var(--rmpe-logo-color, #61dafb);\n  height: 8rem;\n  margin-bottom: 3rem;\n  pointer-events: none;\n  animation: ", " infinite 20s linear;\n"])), rotate);
export var Logo = /*#__PURE__*/_jsxs(SVG, {
  width: "100%",
  height: "100%",
  viewBox: "-10.5 -9.45 21 18.9",
  fill: "none",
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "0",
    cy: "0",
    r: "2",
    fill: "currentColor"
  }), /*#__PURE__*/_jsxs("g", {
    stroke: "currentColor",
    strokeWidth: "1",
    fill: "none",
    children: [/*#__PURE__*/_jsx("ellipse", {
      rx: "10",
      ry: "4.5"
    }), /*#__PURE__*/_jsx("ellipse", {
      rx: "10",
      ry: "4.5",
      transform: "rotate(60)"
    }), /*#__PURE__*/_jsx("ellipse", {
      rx: "10",
      ry: "4.5",
      transform: "rotate(120)"
    })]
  })]
});